import React from "react"
export function CheckboxCircle(props) {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <g
        id="prefix__Artboard-Copy-26"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm3.165 5.107L6.362 9.246 4.433 7.032l-1.13.986 2.42 2.776.071.072a.75.75 0 00.983.003l5.367-4.626-.98-1.136z"
          id="prefix__Combined-Shape"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
